import config from 'config';
import utils from 'utils';

const baseUrl = config.api[window.location.hostname].baseUrl;

const getSuggestion = ({ photoId, candidateSpotIds, model, regenerate, queue }) => {
  return fetch(`${baseUrl}/mod/auto-moderation/suggestions`, {
    method: 'POST',
    headers: {
      Authorization: window.user.token,
      ...utils.getHeaders(),
    },
    body: JSON.stringify({ photoId, candidateSpotIds, model, regenerate, queue }),
  }).then(utils.fetch.process);
};

const getDetectiveQueue = () => {
  return fetch(`${baseUrl}/mod/auto-moderation/detective/queue`, {
    method: 'GET',
    headers: {
      Authorization: window.user.token,
      ...utils.getHeaders(),
    },
  }).then(utils.fetch.process);
};

// The pile is far too large to read from the beginning every time, so each page
// carries the id it stopped on and the next call starts after it.
const getUnsplashQueue = ({ after, nearSpots, safe, pointKind } = {}) => {
  const cursor = after ? `&after=${encodeURIComponent(after)}` : '';
  const near = nearSpots ? '&nearSpots=1' : '';
  const safeFilter = safe ? `&safe=1${pointKind ? `&pointKind=${pointKind}` : ''}` : '';

  return fetch(`${baseUrl}/mod/auto-moderation/unsplash/queue?limit=60${cursor}${near}${safeFilter}`, {
    method: 'GET',
    headers: {
      Authorization: window.user.token,
      ...utils.getHeaders(),
    },
  }).then(utils.fetch.process);
};

const getGroupRepresentative = ({ photoIds, model }) => {
  return fetch(`${baseUrl}/mod/auto-moderation/group-representative`, {
    method: 'POST',
    headers: {
      Authorization: window.user.token,
      ...utils.getHeaders(),
    },
    body: JSON.stringify({ photoIds, model }),
  }).then(utils.fetch.process);
};

const reviewSuggestion = ({ suggestionId, ...review }) => {
  return fetch(
    `${baseUrl}/mod/auto-moderation/suggestions/${encodeURIComponent(suggestionId)}/review`,
    {
      method: 'POST',
      headers: {
        Authorization: window.user.token,
        ...utils.getHeaders(),
      },
      body: JSON.stringify(review),
    }
  ).then(utils.fetch.process);
};

const recoverApplying = () => {
  return fetch(`${baseUrl}/mod/auto-moderation/recover`, {
    method: 'POST',
    headers: {
      Authorization: window.user.token,
      ...utils.getHeaders(),
    },
    body: JSON.stringify({}),
  }).then(utils.fetch.process);
};

const getBenchBatch = ({ limit } = {}) => {
  const query = new URLSearchParams();

  if (limit) {
    query.set('limit', String(limit));
  }

  return fetch(`${baseUrl}/mod/auto-moderation/bench?${query.toString()}`, {
    method: 'GET',
    headers: {
      Authorization: window.user.token,
      ...utils.getHeaders(),
    },
  }).then(utils.fetch.process);
};

const runBenchPhoto = ({ photoId, candidateSpotIds, model }) => {
  return fetch(`${baseUrl}/mod/auto-moderation/bench`, {
    method: 'POST',
    headers: {
      Authorization: window.user.token,
      ...utils.getHeaders(),
    },
    body: JSON.stringify({ photoId, candidateSpotIds, model }),
  }).then(utils.fetch.process);
};

const getSuperSpotQuestions = ({ limit } = {}) => {
  const query = new URLSearchParams();

  if (limit) {
    query.set('limit', String(limit));
  }

  return fetch(`${baseUrl}/mod/auto-moderation/super-spot-questions?${query.toString()}`, {
    method: 'GET',
    headers: {
      Authorization: window.user.token,
      ...utils.getHeaders(),
    },
  }).then(utils.fetch.process);
};

const saveSuperSpotReason = ({ spotId, reason, source, photoId }) => {
  return fetch(`${baseUrl}/mod/auto-moderation/super-spot-reasons`, {
    method: 'POST',
    headers: {
      Authorization: window.user.token,
      ...utils.getHeaders(),
    },
    body: JSON.stringify({ spotId, reason, source, photoId }),
  }).then(utils.fetch.process);
};

// What Auto Mod has spent of today's complimentary tokens, by tier, as the
// backend stored it - whoever asked for it.
const getTokenUsage = () => {
  return fetch(`${baseUrl}/mod/auto-moderation/token-usage`, {
    method: 'GET',
    headers: {
      Authorization: window.user.token,
      ...utils.getHeaders(),
    },
  }).then(utils.fetch.process);
};

const apiAutoModeration = {
  getBenchBatch,
  getTokenUsage,
  getSuperSpotQuestions,
  runBenchPhoto,
  saveSuperSpotReason,
  getDetectiveQueue,
  getUnsplashQueue,
  getGroupRepresentative,
  getSuggestion,
  recoverApplying,
  reviewSuggestion,
};

export default apiAutoModeration;
